import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { IframeAuthService } from '../../shared/services/iframe-auth.service';

export const iframeAuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(IframeAuthService);

  // Verificar si estamos en contexto de iframe
  if (window.parent !== window) {
    // En iframe: verificar que hayamos recibido datos del usuario
    const hasAuthData = authService.hasReceivedAuthData();
    const isAuth = authService.isAuthenticated();

    if (!hasAuthData || !isAuth) {
      return false;
    }

    return true;
  }

  // No estamos en iframe, permitir acceso normal
  return true;
};
